// utils/scrollLock.js
import { useEffect } from 'react';

let locks = 0;

// Save/restore previous inline styles so we don't clobber them
const prev = {
  touchAction: '',
  paddingRight: '',
};

function isLargeDevice() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= 768;
}

// Width the scrollbar actually occupies. Zero with overlay scrollbars (macOS, most touch
// devices), ~15px with classic ones (Windows). Must be read before the body is set to
// `overflow: hidden`, which is what removes the scrollbar in the first place.
function getScrollbarWidth() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return 0;
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

export function lockBody() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return; // SSR guard
  const b = document.body;

  if (locks === 0) {
    // capture existing inline styles once
    prev.touchAction = b.style.touchAction;
    prev.paddingRight = b.style.paddingRight;

    // Replace the width the vanishing scrollbar leaves behind, so the page doesn't shift.
    // Padding it by a hardcoded amount shifts the page the other way wherever the scrollbar
    // is an overlay and takes up no width at all.
    const scrollbarWidth = getScrollbarWidth();
    if (isLargeDevice() && scrollbarWidth > 0) {
      b.style.paddingRight = `calc(${prev.paddingRight || '0px'} + ${scrollbarWidth}px)`;
    }

    // Handle touch action - let app--noscroll handle overflow
    b.style.touchAction = 'none'; // extra: blocks gestures on some devices
  }

  locks += 1;
}

export function unlockBody() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const b = document.body;

  locks = Math.max(locks - 1, 0);
  if (locks === 0) {
    // restore previous inline styles
    b.style.touchAction = prev.touchAction;
    b.style.paddingRight = prev.paddingRight;

    // No scroll position changes - page stays exactly where it was
  }
}

// React hook wrapper
export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return;
    lockBody();
    return () => unlockBody();
  }, [active]);
}
